import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_PREFIX } from '../transport/endpoints';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const token = authService.token;
  const authenticatedRequest = shouldAttachApiAuth(request.url)
    ? request.clone({
      setHeaders: {
        Accept: 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    })
    : request;

  return next(authenticatedRequest);
};

function shouldAttachApiAuth(url: string): boolean {
  if (url === API_PREFIX || url.startsWith(`${API_PREFIX}/`)) {
    return true;
  }

  if (!/^https?:\/\//.test(url)) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);

    return parsedUrl.origin === window.location.origin
      && (parsedUrl.pathname === API_PREFIX || parsedUrl.pathname.startsWith(`${API_PREFIX}/`));
  } catch {
    return false;
  }
}
